import axios from 'axios';

import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
  CONTRACT_RENEWAL_ACTION,
  CONTRACT_ALL_RENEWAL,
  CONTRACT_ADD_RENEWAL,
  CONTRACT_FETCH_RENEWAL,
  CONTRACT_EDIT_RENEWAL,
  CONTRACT_DELETE_RENEWAL,
} from 'Actions/types';
import { NotificationManager } from 'react-notifications';

const getFieldValue = (form, name) => {
  const field = form[name];
  if (!field) {
    return '';
  }
  return field.value != null ? field.value : '';
};

export const contractRenewalList = () => {
  return (dispatch) => {
    dispatch({ type: CONTRACT_RENEWAL_ACTION });
    return axios
      .get(AppConfig.apiurl + '/api/getcontractrenewal', { headers: AuthHeader.header })
      .then((response) => {
        const alldata = response.data.data || [];
        dispatch({ type: CONTRACT_ALL_RENEWAL, payload: alldata });
      });
  };
};

export const studentRecentAgreement = (id) => {
  const payload = { id };
  return (dispatch) => {
    return axios
      .post(AppConfig.apiurl + '/api/getstudlatestagreement', payload, {
        headers: AuthHeader.header,
      })
      .then((response) => {
        return Promise.resolve(response.data);
      });
  };
};

export const addContractRenewal = (data) => {
  const form = data.target;
  const payload = {
    studentid: getFieldValue(form, 'student'),
    agreementid: getFieldValue(form, 'agreementid'),
    expirydate: getFieldValue(form, 'expirydate'),
    agreementprogram: getFieldValue(form, 'agreementtype'),
    totalamount: getFieldValue(form, 'totalamount'),
    miscellexpense: getFieldValue(form, 'miscellexpense'),
    additionalnotes: getFieldValue(form, 'additionalnotes'),
  };

  for (let i = 1; i <= 4; i++) {
    payload['frduedate_' + i] = getFieldValue(form, 'frduedate_' + i);
    payload['frfees_' + i] = getFieldValue(form, 'frfees_' + i);
    payload['frtax_' + i] = getFieldValue(form, 'frtax_' + i);
  }

  return (dispatch) => {
    dispatch({ type: CONTRACT_RENEWAL_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/addcontractrenewal', payload, {
        headers: AuthHeader.header,
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          contractRenewalList()(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: CONTRACT_ADD_RENEWAL });
        } else {
          NotificationManager.error(resdata.message);
        }
        return Promise.resolve(resdata);
      });
  };
};

export const fetchContractRenewal = (id) => {
  const payload = { id };
  return (dispatch) => {
    dispatch({ type: CONTRACT_RENEWAL_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/fetchcontractrenewal', payload, {
        headers: AuthHeader.header,
      })
      .then((response) => {
        const resdata = response.data;
        dispatch({ type: CONTRACT_FETCH_RENEWAL, payload: resdata.data });
        return Promise.resolve(resdata);
      });
  };
};

export const editContractRenewal = (data) => {
  const form = data.target;
  const payload = {
    id: getFieldValue(form, 'eid'),
    studentid: getFieldValue(form, 'stdid'),
    agreementprogram: getFieldValue(form, 'agreementtype'),
    totalamount: getFieldValue(form, 'totalamount'),
    miscellexpense: getFieldValue(form, 'miscellexpense'),
    additionalnotes: getFieldValue(form, 'additionalnotes'),
    renewalstatus: getFieldValue(form, 'renewalstatus'),
  };

  for (let i = 1; i <= 4; i++) {
    payload['frduedate_' + i] = getFieldValue(form, 'frduedate_' + i);
    payload['frfees_' + i] = getFieldValue(form, 'frfees_' + i);
    payload['frtax_' + i] = getFieldValue(form, 'frtax_' + i);
  }

  return (dispatch) => {
    dispatch({ type: CONTRACT_RENEWAL_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/editcontractrenewal', payload, {
        headers: AuthHeader.header,
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          contractRenewalList()(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: CONTRACT_EDIT_RENEWAL });
        } else {
          NotificationManager.error(resdata.message);
        }
        return Promise.resolve(resdata);
      });
  };
};

export const deleteContractRenewal = (id) => {
  const payload = { id };
  return (dispatch) => {
    dispatch({ type: CONTRACT_RENEWAL_ACTION });
    return axios
      .post(AppConfig.apiurl + '/api/deletecontractrenewal', payload, {
        headers: AuthHeader.header,
      })
      .then((response) => {
        const resdata = response.data;
        if (resdata.status === 1) {
          contractRenewalList()(dispatch);
          NotificationManager.success(resdata.message);
          dispatch({ type: CONTRACT_DELETE_RENEWAL });
        } else {
          NotificationManager.error(resdata.message);
        }
      });
  };
};
